var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10449 8.9884L3.51309 9.79477L2.41361 8.9884L3.51309 8.18203L4.10449 8.9884ZM17.912 7.9884C18.4643 7.9884 18.912 8.43611 18.912 8.9884C18.912 9.54068 18.4643 9.9884 17.912 9.9884V7.9884ZM9.0361 13.8454L3.51309 9.79477L4.6959 8.18203L10.2189 12.2327L9.0361 13.8454ZM3.51309 8.18203L9.0361 4.13136L10.2189 5.74411L4.6959 9.79477L3.51309 8.18203ZM4.10449 7.9884H17.912V9.9884H4.10449V7.9884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow_left.31f71132a0d2e3921cafea6d0f869d41.svg";
export { ForwardRef as ReactComponent };